export enum LoaderType {
    OBJ = "obj",
    OBJMTL = "obj/mtl",
    PIXI = "pixi",
    FBX = "fbx",
    GLTF = "gltf",
    WASM = "wasm",
    JSON = "json"
}